<template>
    <div style="width:100%;height:100%;position: relative;">
  
      <el-form ref="loginFormRef" :model="LoginForm" class="login-form" :rules="rules">
        <div class="loginBodyCss_tittle">欢迎使用华源供应链仓配一体化平台</div>
        <div class="loginTitleCss">
          <div :class="['loginTitleCss_tap' ,{'loginTitleCss_tap_isActive': !adminDcVerify}]" @click="updateTab(false)">账号登录</div>
          <!-- <div class="lineCss"></div> -->
          <div :class="['loginTitleCss_tap' ,{'loginTitleCss_tap_isActive': adminDcVerify}]" @click="updateTab(true)">短信登录</div>
        </div>
        <div class="loginBodyCss">
  
          <template v-if="adminDcVerify">
            <div class="itemTitleCss">登录手机号</div>
            <el-form-item prop="loginPhone">
              <el-input ref="loginPhone" type="input" placeholder="手机号" v-model="LoginForm.loginPhone" autocomplete="off" maxlength="20" v-on:keyup.enter.native="login" @change="loginNameChange">
              </el-input>
            </el-form-item>
            <div class="itemTitleCss" style="margin-top:15px">验证码</div>
            <el-form-item prop="smsCode">
              <el-input type="input" placeholder="短信验证码" v-model.trim="LoginForm.smsCode" maxlength="6" autocomplete="off">
                <template slot="suffix">
                  <div style="display:flex;align-items:center;height:100%;padding-right:20px">
                    <div class="lineCss" style="margin-right:20px"></div>
                    <el-button type="text" :disabled="this.getSmsCodeStatus" @click="getSmsCode('loginFormRef')">
                      {{this.getSmsCodeName}}
                    </el-button>
                  </div>
                </template>
              </el-input>
            </el-form-item>
          </template>
          <template v-else>
            <div class="itemTitleCss">账号名</div>
            <el-form-item prop="loginName">
              <el-input ref="loginName" type="input" placeholder="账号名" v-model="LoginForm.loginName" autocomplete="off" maxlength="20" v-on:keyup.enter.native="login" @change="loginNameChange">
              </el-input>
            </el-form-item>
            <div class="itemTitleCss" style="margin-top:15px">登录密码</div>
            <el-form-item prop="password">
              <el-input type="password" placeholder="登录密码" v-model.trim="LoginForm.password" autocomplete="off" maxlength="20" v-on:keyup.enter.native="login" show-password>
              </el-input>
            </el-form-item>
          </template>
  
          <el-form-item v-if="showVerify" prop="verify" style="margin-top: 22px">
            <el-row>
              <el-col :span="16">
                <el-input type="input" placeholder="图片验证码（区分大小写）" v-model="LoginForm.verify" autocomplete="off"></el-input>
              </el-col>
              <el-col :span="8" style="height:47px">
                <!-- <span style="height:47px"> -->
                <el-image @click="changeImgCode" fit="fill" :src="verifyUrl" style="width: 100%;height:47px;cursor: pointer;float:right" />
                <!-- </span> -->
              </el-col>
            </el-row>
          </el-form-item>
  
          <div style="font-size:14px;margin:20px 0 30px">
            登录视为您已阅读并同意
            <el-button @click="lookService" style="padding:0" type="text">《服务条款》</el-button>与
            <el-button @click="lookProtocolPrivacy" style="margin:0;padding:0" type="text">《隐私条款》</el-button>
          </div>
          <el-button type="primary" style="width:100%;" @click="login" v-loading.fullscreen.lock="fullscreenLoading">登 录
          </el-button>
          <el-button type="text" style="width:100%;margin-left: 0;" @click="registBtn">立即注册</el-button>
          <div style="text-align:center">
            <el-button type="text" style="color: #808080;margin-left: 10px;" @click="forgotPass">忘记密码？</el-button>
          </div>
        </div>
      </el-form>
      <el-dialog title="" :visible.sync="procolVisible" width="60%" center :modal-append-to-body="false">
        <span v-html="agreement"></span>
      </el-dialog>
    </div>
  </template>
  
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  import ls from "@/utils/ls";
  import userAPI from "@/api/userAPI.js";
  import aEntityAPI from "@/api/sysAPI.js";
  import aes from './aes.js';
  import QRCode from 'qrcode';
  import io from "../components/socket.io";
  //import selectOrganList from "./selectOrganList.vue";
  
  export default {
    components: {},
    props: ["mobile", "saas", "fromUrl"],
    data() {
      let checkMobile = (rule, value, callback) => {
        if (!value) {
          callback(new Error("手机号不能为空"));
        }
        let re = /(^[\\\-0-9][0-9]*(.[0-9]+)?)$/; //判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/
        if (!re.test(value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (value.length != 11) {
            callback(new Error("手机号格式不正确"));
          } else {
            callback();
          }
        }
      };
      let checkSmsCode = (rule, value, callback) => {
        if (!value) {
          callback(new Error("短信验证码不能为空"));
        }
        let re = /(^[\\\-0-9][0-9]*(.[0-9]+)?)$/; //判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/
        if (!re.test(value)) {
          callback(new Error("请输入数字值"));
        } else {
          // if(value.length != 4){
          //   callback(new Error('请输入4位短信验证码'));
          // }else{
          callback();
          // }
        }
      };
      return {
        isMobile: false,
        timer: null,
        qrExpire: false,
        qrLoginLock: false,
        qrLoginerror: false,
        loginWebSocket: null,
        isQrcode: false,
        qrcode: null,
        uuid: null,
  
        fullscreenLoading: false,
        hrsaas: false,
  
        adminDcVerify: false, //等保针对管理员，double check sms verify
        getSmsCodeName: "获取短信验证码",
        getSmsCodeStatus: false,
  
        LoginForm: {
          loginName: "",
          password: "",
          smsCode: "",
          verify: "",
          loginPhone: ""
        },
        showVerify: false,
        verifyUrl: window.location.protocol + "//" + window.location.host + process.env.VUE_APP_BACKEND_URL_PROXY + "/verify?randid=" + Math.abs(Math.sin(new Date().getTime())),
        rules: {
          loginName: [
            {
              required: true,
              message: "请输入用户名",
              trigger: "change"
            }
          ],
          password: [
            {
              required: true,
              message: "请输入密码",
              trigger: "change"
            }
          ],
          verify: [
            {
              required: true,
              message: "请输入图片验证码",
              trigger: "change"
            }
          ],
          loginPhone: [
            {
              required: true,
              message: "请输入手机号",
              trigger: "change"
            },
            { validator: checkMobile, trigger: "blur" }
          ],
          smsCode: [
            {
              required: true,
              message: "请输入短信验证码",
              trigger: "change"
            },
            { validator: checkSmsCode, trigger: "blur" }
          ],
        },
        loginRole: '',
        loginRoleName: '',
        isSaaS: false,
        organDialogVisible: false,
        currentOrgan: null,
        confirmOrganLoading: false,
        agreement: '',
        procolVisible: false,
      };
    },
    computed: {
      ...mapGetters({
        userinfo: "user/userinfo",
        sysConfig: "config/sysConfig",
        shipper: "user/shipper",
        __menu: "user/menu"
      })
    },
  
    created() {
      if (ls.get("LoginError") != null && ls.get("LoginError") == 1) {
        this.showVerify = true
      }
    },
  
    methods: {
      ...mapActions(["user/login", "user/logout", "user/checkLogin", "user/refreshShipperAndOrgan"]),
      updateTab(tab) {
        this.adminDcVerify = tab
      },
      //服务条款
      lookService() {
        let params = {
          type: 3,
          code: 'wlhy'
        };
        userAPI.getProductContract(params).then(res => {
          if (res.data.success) {
            this.agreement = res.data.data;
            this.procolVisible = true;
          }
        });
      },
      //隐私协议查看
      lookProtocolPrivacy() {
        let params = {
          type: 4,
          code: 'privacy'
        };
        userAPI.getProductContract(params).then(res => {
          if (res.data.success) {
            this.agreement = res.data.data;
            this.procolVisible = true;
          }
        });
      },
  
  
      loginNameChange(v) {
  
        /*检查是否需要图片验证码*/
        userAPI.needVerify(v).then(response => {
          //双要素验证
          if (response.status != null && response.status == 200) {
            if (response.data.needVerify) {
              this.showVerify = true
            }
          }
        });
  
        //需要双要速验证
        if (this.sysConfig.adminSmsVerifyLogin) {
          userAPI.checkAdmin(v).then(response => {
            //双要素验证
            if (response.status != null && response.status == 200) {
              if (response.data.admin) {
                this.$message({
                  message: "已启用超管的密码 + 短信验证码双要素登录策略",
                  type: "info"
                });
                this.adminDcVerify = true
                return;
              }
            }
  
            this.adminDcVerify = false
          })
        }
  
      },
  
      //获取短信验证码
      getSmsCode(ref) {
        let valid = true;
        this.$refs[ref].clearValidate();
        this.$refs[ref].validateField(["loginPhone"], err => {
          if (err != "") {
            valid = false;
          }
        });
  
        if (valid) {
          let params = {
            mobile: this.LoginForm.loginPhone
          };
  
          userAPI.getSmsCode(params).then(response => {
            if (response.status != null && response.status == 200) {
              this.waitCodeTime();
            } else {
              let message =
                response.data.message == null ? "获取验证码失败" : response.data.message;
              this.$message({
                message: message,
                type: "error"
              });
            }
          });
        }
      },
  
  
      //短信验证码倒计时
      waitCodeTime() {
        let waitSeconds = 60;
        this.getSmsCodeStatus = true;
        var interval = setInterval(() => {
          waitSeconds--;
          this.getSmsCodeName = "校验码已发送，请等待" + waitSeconds + "秒重试";
          this.getSmsCodeStatus = true;
          if (waitSeconds < 1) {
            this.getSmsCodeName = "没收到验证码？重新获取";
            this.getSmsCodeStatus = false;
            clearInterval(interval);
          }
        }, 1000);
      },
  
      login() {
        this.$refs.loginFormRef.validate(valid => {
          if (valid) {
            this.fullscreenLoading = true;
            var param = { ...this.LoginForm }
            //加密密码防止泄露
            param.passwordE = aes.encrypt(param.password)
            param.password = null;
            if (this.adminDcVerify == true) {
              param.loginName = this.LoginForm.loginPhone
              // param.smsVerify = this.LoginForm.smsCode //短信验证码设置为双要素的短信校验码
              // param.smsCode = ""//避免与短信验证码登录冲突
              param.passwordE = null//制空密码
            } else {
              param.smsCode = ""//账号登录情况验证码
            }
            this["user/login"](param).then(data => {
              this.fullscreenLoading = false;
              if (data.success) {
                console.log(data)
                var tenantInfo = data.tenantInfo;
                let organList = data.organList;//雨虹机构列表
  
                if (tenantInfo?.domain) {
                  ls.set("tenantDomain", tenantInfo.domain.split(",")[0])
                }
  
                if (sessionStorage.getItem("beforeLoginUrl") == null) {
                  if (data.user.firstLogin) {
                    //首次登录
                    this.$router.push({ name: "resetPass" });
                  } else {
                    if (this.fromUrl != null && this.fromUrl) {
                      window.location.href = decodeURIComponent(this.fromUrl);
                    } else {
                      if (this.__menu.length == 1) {
                        //一个系统菜单，只进这个系统
                        const url = this.__menu[0].url;
                        window.location.href = url;
                      } else if (this.__menu.length > 1) {
                        //多个系统菜单
                        let tmsFlag = false;
                        for (var i = 0; i < this.__menu.length; i++) {
                          if (this.__menu[i].mxtype == 'tms') {
                            tmsFlag = true;
                          }
                        }
  
                        if (tmsFlag) {
                          window.location.href = "tms.html#/home";
                        } else {
                          const url = this.__menu[0].url
                          window.location.href = url
                        }
                      } else {
                        //无菜单
                        this.$alert("无系统权限，将返回登录", "登录失败", {
                          confirmButtonText: "确定",
                          callback: action => {
                            this["user/logout"]().then(() => {
                              window.location.reload();
                            });
                          }
                        });
                      }
  
                    }
                  }
  
                } else {
                  var beforeLoginUrl = sessionStorage.getItem("beforeLoginUrl")
                  sessionStorage.removeItem("beforeLoginUrl")
                  window.location.href = beforeLoginUrl;
                }
  
              } else {
                let message = data.msg == null ? "" : data.msg;
                if (message == "该号码未注册") {
                  this.$message({
                    message: "该手机号未注册，请您先注册！",
                    type: "error"
                  });
                } else {
                  if (data.errorCode == 407) {
                    this.$message({
                      message: "已启用超管的密码 + 短信验证码双要素登录策略",
                      type: "info"
                    });
                    this.adminDcVerify = true
                    return;
                  }
  
                  if (data.errorTimes >= 3 || message == "图片验证码不正确") {
                    this.showVerify = true;
                    ls.set("LoginError", 1);
                  }
                  this.$message({
                    message: message,
                    type: "error"
                  });
                  if (this.showVerify) {
                    //刷新验证码
                    this.changeImgCode();
                  }
                }
              }
            });
          }
        });
      },
      registBtn() {
            this.$router.push({ name: "reg" });
        },
      forgotPass() {
        this.$router.push({ name: "forgotPass" });
      },
      changeImgCode() {
  
        this.LoginForm.verify = "" //清空验证码
  
        this.verifyUrl =
          window.location.protocol +
          "//" +
          window.location.host +
          process.env.VUE_APP_BACKEND_URL_PROXY +
          "/verify?randid=" +
          Math.abs(Math.sin(new Date().getTime()));
      },
      selectOrgan(val) {
        this.currentOrgan = val;
      },
      //确认选择机构
      confirmOrgan() {
        let _this = this;
        // console.log(_this.currentOrgan,'currentOrgan');
        let organ = _this.currentOrgan;
        this.$confirm('<span style="font-size:16px;">确定选择工厂机构【<span style="color:#F56C6C">' + organ.organName + '</span>】，所属发货人</br>【<span style="color:#F56C6C">' + organ.shipperName + '</span>】吗？</span>', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: '',
          callback: (action, instance) => {
            if (action == 'confirm') {
              _this.confirmOrganLoading = true;
              _this.organDialogVisible = false;//弹框
              _this.fullscreenLoading = true;
              let params = {
                shipperId: organ.pid,
                organId: organ.id
              }
              this["user/refreshShipperAndOrgan"](params).then(data => {
                _this.confirmOrganLoading = false;
                _this.fullscreenLoading = false;
                if (data.success) {
                  //判断默认进入的系统
                  let menu = data.menuTree;
                  if (menu.length == 1) {
                    //一个系统菜单，只进这个系统
                    const url = menu[0].url;
                    window.location.href = url;
                  } else if (menu.length > 1) {
                    //多个系统菜单
                    // let manageFlag = false;
                    // for (var i = 0; i < menu.length; i++) {
                    //   if (menu[i].mxtype == 'manage') {
                    //     manageFlag = true;
                    //   }
                    // }
                    let wlhyFlag = false;
                    for (var i = 0; i < menu.length; i++) {
                      if (menu[i].mxtype == 'wlhy30') {
                        wlhyFlag = true;
                      }
                    }
                    if (wlhyFlag) {
                      window.location.href = "wlhy30.html#/home";
                    } else {
                      const url = menu[0].url
                      window.location.href = url
                    }
                  } else {
                    //无菜单
                    this.$alert("无系统权限，将返回登录", "登录失败", {
                      confirmButtonText: "确定",
                      callback: action => {
                        this["user/logout"]().then(() => {
                          window.location.reload();
                        });
                      }
                    });
                  }
                }
              })
            }
          }
        })
      }
    },
  
    mounted() {
      var href = window.location.href;
      if (this.mobile) {
        this.LoginForm.loginName = this.mobile;
      }
      var that = this
      setTimeout(function () {
        that.$refs['loginName'].focus()
      }, 250)
  
    },
  };
  </script>
  <style lang="scss" scoped>
  .login-divider.el-divider--horizontal {
    margin: 12px 0;
  }
  
  .qrcode {
    width: 200px !important;
    height: 200px !important;
  }
  
  .rightBottomCss {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 5;
    /* width: 50px;
          height: 50px; */
    /* background-color: red; */
  }
  
  .wrapper {
    position: relative;
    display: inline-block;
  }
  
  .triangle1 {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    border-top: 40px solid rgb(255, 255, 255);
    border-bottom: 40px solid transparent;
    border-left: 40px solid rgb(255, 255, 255);
    border-right: 40px solid transparent;
    z-index: 20;
  }
  
  .triangle2 {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    border-top: 30px solid rgb(255, 255, 255);
    border-bottom: 30px solid transparent;
    border-left: 30px solid rgb(255, 255, 255);
    border-right: 30px solid transparent;
    z-index: 20;
  }
  
  .img1CSS {
    display: block;
    position: relative;
    z-index: 10;
    width: 80px;
    height: 80px;
  }
  
  .img2CSS {
    display: block;
    position: relative;
    z-index: 10;
    width: 80px;
    height: 80px;
  }
  
  .bubble-wrap {
    width: 140px;
    height: 40px;
    background-color: #f9e4dc;
    position: absolute;
    bottom: 25px;
    right: 80px;
    color: #fe5918;
    line-height: 40px;
    text-align: center;
    font-size: 12px;
    border: 1px solid #fe5918;
  }
  
  .bubble-arrow {
    top: 8px;
    right: 0;
    position: absolute;
    z-index: 30;
  }
  
  .span1Css {
    border-left-color: #fe5918;
    left: 1px;
    border-width: 6px 6px 6px 6px;
    position: absolute;
    width: 0;
    height: 0;
    /* border-color: tomato; */
    border-style: solid;
    overflow: hidden;
    top: 5px;
    border-right-color: rgba(255, 255, 255, 0);
    border-top-color: rgba(255, 255, 255, 0);
    border-bottom-color: rgba(255, 255, 255, 0);
    z-index: 35;
  }
  
  .span2Css {
    border-left-color: #f9e4dc;
    border-width: 6px 6px 6px 6px;
    position: absolute;
    width: 0;
    height: 0;
    /* border-color: #f9e4dc; */
    border-style: solid;
    overflow: hidden;
    top: 5px;
    border-right-color: rgba(255, 255, 255, 0);
    border-top-color: rgba(255, 255, 255, 0);
    border-bottom-color: rgba(255, 255, 255, 0);
    left: 0;
    z-index: 40;
  }
  
  .mask {
    position: absolute;
    left: 24%;
    /* top: 0;
    left: 0; */
    width: 200px;
    height: 200px;
    background-color: #fff;
    /* 蒙版层的颜色 */
    opacity: 0.9;
    /* 蒙版层的透明度, 可设置0-1之间的数值*/
  }
  
  .loginTitleCss {
    height: 50px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
  
  .loginTitleCss_tap {
    height: 100%;
    line-height: 66px;
    font-weight: 400;
    font-size: 18px;
    color: #808080;
    cursor: pointer;
    margin-right: 40px;
  }
  
  .loginTitleCss_tap_isActive {
    color: #0055ff;
    border-bottom: 2px solid #0055ff;
  }
  
  .lineCss {
    height: 20px;
    border: 1px solid #dfe1e6;
  }
  
  .loginBodyCss {
    width: 100%;
    padding: 35px 0;
    box-sizing: border-box;
  }
  
  .loginBodyCss_tittle {
    font-weight: bold;
    font-size: 24px;
    color: #191919;
    margin-bottom: 15px;
  }
  
  /deep/
    .el-form-item.is-required:not(.is-no-asterisk)
    > .el-form-item__content
    .el-input
    .el-input__inner {
    background: #ffffff;
    border: 1px solid #cccccc;
  }
  
  .itemTitleCss {
    font-weight: 400;
    font-size: 18px;
    color: #808080;
    margin-bottom: 10px;
  }
  
  /deep/ .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    background: rgba(0, 0, 0, 0);
  }
  </style>
  